<template>
  <div>
    <ZtLink :to="url" class="link is-grey block text-size-3 leading-none">
      <SpriteSymbol :name="socialIcon" />
    </ZtLink>
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphLinkFragment } from '#graphql-operations'
import type { NuxtSvgSpriteSymbol } from '#nuxt-svg-sprite/runtime'

const props = defineProps<{
  link?: ParagraphLinkFragment['link']
}>()

defineBlokkli({
  bundle: 'link',
  globalOptions: ['bkHiddenGlobally'],
  renderFor: {
    fieldListType: 'socialLinks',
  },
})

const url = computed(() => props.link?.uri?.path || '')

const socialIcon = computed<NuxtSvgSpriteSymbol>(() => {
  if (url.value.includes('twitter.com') || url.value.includes('x.com')) {
    return 'twitter'
  } else if (url.value.includes('facebook.com')) {
    return 'facebook'
  } else if (url.value.includes('pinterest.com')) {
    return 'pinterest'
  } else if (url.value.includes('youtube')) {
    return 'youtube'
  } else if (url.value.includes('instagram')) {
    return 'instagram'
  } else if (url.value.includes('linkedin')) {
    return 'linkedin'
  }

  return 'email'
})
</script>
